import { createContext, useContext } from 'react';
import * as React from 'react';
import noop from '@sdk/utils/noop';

import { ShiftTasksBridgeState } from './shiftTasksBridgeProvider.types';

type Props = {
  children: React.ReactNode;
  shiftTasksBridge: ShiftTasksBridgeState;
};

export const ShiftTasksBridgeStateContext = createContext<ShiftTasksBridgeState>({
  onAddTaskTemplate: noop,
  onEditTaskTemplate: noop,
  onEditTaskInstance: noop,
} as ShiftTasksBridgeState);
export const useShiftTasksBridge = () => useContext(ShiftTasksBridgeStateContext);

export const ShiftTasksBridgeProvider = ({ shiftTasksBridge, children }: Props) => (
  <ShiftTasksBridgeStateContext.Provider value={shiftTasksBridge}>
    {children}
  </ShiftTasksBridgeStateContext.Provider>
);
